import React from 'react';
import Typography from '@mui/material/Typography';
import { Button, ButtonProps } from '@mui/material';
import styles from './JumboBanner.module.scss';
import { ShadeBackground } from 'new/elements/ShadeBackground';
type Props = {
  title: string;
  description?: string;
  cta?: ButtonProps;
};

export function JumboBanner(props: Props) {
  return (
    <div className={styles.root}>
      <ShadeBackground />
      <div className={styles.container}>
        <div className={styles.content}>
          <Typography variant="h4">{props.title}</Typography>
          <Typography variant="body1">{props.description}</Typography>
          {props.cta ? (
            <Button size="large" variant="contained" color="primary" {...props.cta}>
              {props.cta?.title}
            </Button>
          ) : null}
        </div>
        <div style={{ flex: 1 }} />
      </div>
    </div>
  );
}
